/* MI DOMINO - app entry. A thin bootstrap: the shared state loads in ./state,
 * the catalog completes itself in ./data/catalog, and every feature lives in
 * its module. This file only calls their init functions, in the order the
 * legacy client wired them (some steps need DOM nodes or earlier steps). */
import { initAdminDB, initInviteLink, initLobby } from './admin/portal';
import { questsInit, renderLobbyQuests } from './economy/quests';
import { applyBling, applyScene, syncFeltSelect, syncSkinSelect, syncWoodSelect, updateCoinBal } from './economy/wallet';
import { initControls } from './game/controls';
import { initDrag } from './game/drag';
import { applyLang, renderGaleria } from './game/engine';
import { applyProfile, initCloudSync, migrateStats, updateRankBadge } from './identity/profile';
import { initCamera } from './media/camera';
import { initAccountMenu, initSession } from './ui/account';
import { initDashboard } from './ui/dashboard';
import { initChat, initEmojiPicker, initLangAndStore, initMobileShell, initPageChrome, initQuickPhrases, initSettingsPanel, initShellTabs } from './ui/shell';
import { installErrorReporter } from './ui/errlog';
import { initPWA } from './ui/pwa';
import { initOrientation } from './ui/orientation';

/* production bugs → /api/client-error → founder's 🐞 Errors panel. Installed
   first so anything that breaks further down this file is reported too. */
installErrorReporter();

initSettingsPanel();   // ⚙️ selects + hints/sound; restores felt/skin from storage (before the store lists are built)
initControls();        // table buttons: side choice, ¡NO VOY!, undo, corneta, shake hands, New match (table DOM)
initDrag();            // drop zones / rack / felt drop + phone touch-drag (table DOM)
initCamera();          // 🎥 / 🎤 buttons (PRO-gated camera)
syncSkinSelect();   // ⚙️ Fichas list = built-in looks + every set you own (STORE is complete: catalog.ts pushes at module load)
syncFeltSelect();   // ⚙️ Table felt list = built-in felts + every flag/designer table you own
syncWoodSelect();   // ⚙️ Table wood list = classic + every wood you own
applyScene();       // 🌅 ambient scene behind the table
initAdminDB();         // Founder's local ledger: seed demo rows / migrate (needs seedAdminDB)
initPageChrome();      // store page ✕ + ⚙️ toggle
migrateStats();        // old saves → XP / streaks / onlineHands (before the missions snapshot their baseline)
questsInit();          // 🎯 today's three missions (new day → new set, progress from now)
renderLobbyQuests();   // …shown under the lobby buttons
initDashboard();       // dashboard open/close buttons
initShellTabs();       // top-bar tab state + body.table-ui observer (before the door is rendered below)
renderGaleria();       // the gallery fans
initLangAndStore();    // 🛒 tab + language buttons
updateCoinBal();
applyBling();
applyProfile();
applyLang();
updateRankBadge();
initEmojiPicker();     // 😀 chat picker (fills #emoji-pop)
initQuickPhrases();    // ⚡ one-tap table talk (fills #quick-pop)
initChat();            // chat form: socket online, compays offline
initLobby();           // lobby buttons; connects the socket when served online
initInviteLink();      // ?join=CODE deep link prefill (after initLobby: needs the lobby card)
initCloudSync();       // 45s cloud sync + sync on tab hide (when signed in online)
initAccountMenu();     // account chip + dropdown; marks guests; re-applies labels
initSession();         // the door (no account) or the daily gift; expired / merged notices
initMobileShell();     // phone bar + drawer; re-lays the snake on rotate
initOrientation();     // 📱 landscape: turn-your-phone screen on upright phones
initPWA();             // 📲 service worker, "Instalar app", background "¡te toca!" attention
